module.exports = __webpack_public_path__ + "img/referencia.37bbd580.jpg";